import React from 'react'
import { IconPropsType } from '../types'

const RemoveIcon = ({ width = 106, height = 106 }: IconPropsType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 106 106'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='53' cy='53' r='53' fill='#EAB308' fillOpacity='0.1' />
      <circle cx='53' cy='53' r='34.7812' fill='#EAB308' />
      <g clipPath='url(#clip0_14208_27177)'>
        <path
          d='M52.9993 39.1973C45.3806 39.1973 39.1973 45.3806 39.1973 52.9993C39.1973 60.6181 45.3806 66.8014 52.9993 66.8014C60.6181 66.8014 66.8014 60.6181 66.8014 52.9993C66.8014 45.3806 60.6181 39.1973 52.9993 39.1973ZM59.9004 54.3796H46.0983V51.6191H59.9004V54.3796Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_14208_27177'>
          <rect
            width='33.125'
            height='33.125'
            fill='white'
            transform='translate(36.4375 36.4375)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default RemoveIcon
